import { ArrowLeft, ArrowRight, Loader2, SkipForward } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface OnboardingActionBarProps {
  onBack: () => void
  onSkip: () => void
  onNext: () => void
  canGoBack: boolean
  nextLabel: string
  nextDisabled: boolean
  isLoading: boolean
  loadingLabel: string
  creditsHint?: string
}

export function OnboardingActionBar({
  onBack,
  onSkip,
  onNext,
  canGoBack,
  nextLabel,
  nextDisabled,
  isLoading,
  loadingLabel,
  creditsHint,
}: OnboardingActionBarProps) {
  return (
    <div className="sticky bottom-4 z-30 rounded-2xl border border-white/70 bg-white/95 p-3 shadow-[0_12px_35px_rgba(0,0,0,0.12)] backdrop-blur-sm sm:p-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={onBack} disabled={!canGoBack}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>

          <Button variant="ghost" size="sm" onClick={onSkip} className="text-gray-500 hover:text-gray-700">
            <SkipForward className="mr-2 h-4 w-4" />
            Skip onboarding
          </Button>
        </div>

        <div className="flex items-center gap-3">
          {creditsHint && <p className="hidden text-sm text-gray-500 sm:block">{creditsHint}</p>}
          <Button onClick={onNext} disabled={nextDisabled} className="min-w-[170px]">
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {loadingLabel}
              </>
            ) : (
              <>
                {nextLabel}
                <ArrowRight className="ml-2 h-4 w-4" />
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}
